/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tcG9uZW50cy9pbmZpbml0ZS1zZWxlY3QvaW5maW5pdGUtc2VsZWN0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcXVhbmhvYW5nL3plbmlmeS9yZXBvcy9jbGllbnQtZmluYWwvc3JjL2FwcC9jb21wb25lbnRzL2luZmluaXRlLXNlbGVjdC9pbmZpbml0ZS1zZWxlY3QuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/infinite-select/infinite-select.component.css.shim.ngstyle.ts